import type { ID } from '../types';
import BaseObject from './BaseObject';
import { Set } from 'immutable';

export default class Starred extends BaseObject {
  items: Set<ID> = Set();

  constructor(props: any = {}) {
    super(props);

    this.items = props.ids ? Set(props.ids.map(String)) : this.items;
  }
}
